<template>
  <div class="TelephoneForm border m-2 p-2">
    <h3>{{ $t('form.telephone.block_name') }}</h3>
    <div v-if="loaded">
      <TelephoneInput :showErrors="showErrors" :isRequired="true" :value="telephones[0].tnumber || ''" :countryPrefix="telephones[0].prefix" v-on:upd:telephone="maybeSave($event)" />
    </div>
  </div>
</template>

<script>

import {
  getTelephones,
  updateTelephones
} from "@/api/telephone.js";
import { mapGetters } from "vuex";
import TelephoneInput from "@/snippets/TelephoneInput.vue";

export default {
  name: 'TelephoneForm',
  components: {TelephoneInput},
  data() {
    return {
      telephones: [],
      loaded: false,
      hasData: false,
      timeout: undefined,
    };
  },
  props: {
    autoSave: {
      type: Boolean,
      default: true
    },
    showErrors: {
      type: Boolean,
      default: false
    },
    countryPrefix: {
      type:String,
    }
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    }),
    allValid: function () {
      let okTel = 0;
      this.telephones.forEach(tel => {
        if (this.telValid(tel)) {
          okTel++;
        }
      });
      if ( this.telephones.length == okTel) {
        return true;
      } else {
        return false;
      }
    },
    prefixPlaceholder() {
      return this.countryPrefix || this.telephones[0].prefix || 'default'
    }
  },
  created() {
    this.fetchData()
  },
  async beforeDestroy() {
    await this.trySave();
  },
  methods: {
    async fetchData() {
      const rv = await getTelephones(this.$userClient);
      if (rv) {
        if (rv.telephones[0]) {
          this.telephones = rv.telephones;
        }
        else {
          this.telephones = [{tnumber:"",prefix:"+49"}]
        }
        this.loaded = true;
        this.hasData = this.allValid;
      }
    },
    async maybeSave(val) {
      if (val.length > 8) {
        if(this.timeout) clearTimeout(this.timeout);
        var that=this;
        this.timeout = setTimeout(async function() {
          that.telephones[0].tnumber = val;
          that.trySave();
        }, 1000);
      }
    },
    async trySave() {
      if (this.autoSave && this.allValid) {
        await this.updTelephones();
      }
    },
    async updTelephones() {
      const rv = await updateTelephones(this.$userClient, this.telephones);
      if (rv) {
        this.telephones = rv.telephones;
        this.$emit('user-data-updated',{ subform: 'telephone', 'return': rv } );
      }
    },
    telValid(tel) {
      return (tel && tel.tnumber && tel.tnumber.length > 5 && tel.tnumber.length <= 20) ? true : false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
